import * as React from "react"
import { Suspense } from 'react'

import {
    Routes,
    Route,
    NavigateFunction,
    useLocation,
    useNavigate,
    useParams,
} from "react-router-dom";

import SetCookie from "../set-cookie";
import SectionLoader from "./section-loader";
import { ID } from "../types/app-types";

import HomePage from "./homepage";
import ImageEditor from "template-edit/image-editor";
import Previews from "template-previews";
import Diagnostics from "diagnostics/diagnostics";
import Products, { ViewTableType } from "products/containers";
import Settings, {ShowCategoryType} from "settings/containers";
import Superadmin, { AdminMenuType } from "superadmin/containers";
import TemplateList from "template-list/containers/template-list"

export function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        const location = useLocation()
        const navigate = useNavigate()
        const params = useParams()

        return (
            <Component
                {...props}
                router={{location, navigate, params}}
            />
        );
    }

    return ComponentWithRouterProp;
}

export type RouterType = {
    location: {
        pathname: string
        search: string
        hash: string
        key: string
        state: any
    }
    navigate: NavigateFunction
    params: {
        eshop_id: ID
        project_id: ID
        template_id?: ID
        alt_template_id?: ID
        gallery_template_id?: number
        activemenu?: AdminMenuType
        viewtable?: ViewTableType
        showcategory?: ShowCategoryType
        action?: 'from-gallery' | 'new' | number
    }
}

const AppRoutes = () => {
    return <Suspense fallback={<SectionLoader />}>
        <Routes>
            <Route path={`/`} element={<TemplateList />}/>
            <Route path={`/templates`} element={<TemplateList />} />
            <Route path={`/homepage-test`} element={<HomePage />} />
            <Route path={`/templates/:template_id/edit`} element={<ImageEditor isAlt={false} />} />
            <Route path={`/templates/:template_id/edit-alt/:alt_template_id`} element={<ImageEditor isAlt={true} />} />
            <Route path={`/templates/:action`} element={<ImageEditor isAlt={false} />}/>    //action like: new, from-gallery, ...
            <Route path={`/templates/from-gallery/:gallery_template_id`} element={<ImageEditor fromGallery={true} isAlt={false} />} />
            <Route path={`/previews/template/:template_id`} element={<Previews />}/>
            <Route path={`/previews/format/:format_id`} element={<Previews />}/>
            <Route path={`/previews`} element={<Previews/>}/>
            <Route path={`/products`} element={<Products />}/>
            <Route path={`/products/:viewtable`} element={<Products />}/>
            <Route path={`/diagnostics`} element={<Diagnostics />}/>
            <Route path={`/settings`} element={<Settings />}/>
            <Route path={`/settings/:showcategory`} element={<Settings />}/>
            <Route path={`/superadmin`} element={<Superadmin />}/>
            <Route path={`/superadmin/:activemenu`} element={<Superadmin />}/>
            <Route path={`/set-cookie/:fake_project_id`} element={<SetCookie/>}/>
        </Routes>
    </Suspense>
}

export default AppRoutes